import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title: '',
  date: '',
  author: '',
  description: '',
  content: '',
  banner_url: '',
  status: '',
  main_post: 0,
  popular_new: 0,
  title_jp: '',
  description_jp: '',
  content_jp: '',
};
export const newItemSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = newItemSlice.actions;

export default newItemSlice.reducer;
